<template>
  <Form
    ref="loginForm"
    class="login-form"
    :model="model"
    :rules="rules"
    @submit.native.prevent
  >
    <IdentityNoInput
      v-model="model.identityNo"
      prop="identityNo"
      :icon="true"
    />
    <ShowPasswordInput
      v-model="model.password"
      prop="password"
    />
    <BaseCheckbox
      v-model="model.shouldRemember"
      content="記住我的帳號密碼"
    />
    <Button
      long
      class="mb-s btn-primary btn-m"
      :loading="loading"
      @click="handleSubmit"
    >
      <span v-if="!loading">登入</span>
      <span v-else>請稍候</span>
    </Button>
    <slot name="footer" />
  </Form>
</template>

<script>
  // npm
  import { Form, Button } from 'iview';
  // components
  import IdentityNoInput from '@/components/forms/elements/IdentityNoInput';
  import ShowPasswordInput from '@/components/forms/elements/ShowPasswordInput';
  import BaseCheckbox from '@/components/forms/elements/BaseCheckbox';
  // form model & rule
  import { rules, model } from '@/utils/asyncValidator/loginForm';

  export default {
    components: {
      Form,
      Button,
      IdentityNoInput,
      ShowPasswordInput,
      BaseCheckbox
    },
    props: {
      handleLogin: {
        type: Function,
        default: () => {}
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return { rules, model: { ...model } };
    },
    methods: {
      async handleSubmit() {
        const { $refs, model } = this;
        const isValid = await $refs.loginForm.validate(v => v);
        if (!isValid) return;
        this.handleLogin(model);
      }
    }
  };
</script>